import { ContractActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { successType } from '../../services/api-handlers/api-resolver';
import { SagaPromise } from './auth-actions';
import { Dispatch } from 'redux';
import { ContractFormData, ContractSendFormData } from '../../screens/General/screens/Contract/components/ContractForm';

export interface GetContractsAction {
    type: typeof ContractActions.FETCH_CONTRACTS;
    payload: any;
    all?: any;
}

export function getContracts(params: any): GetContractsAction {
    return {
        type: ContractActions.FETCH_CONTRACTS,
        payload: params,
    };
}

export interface GetContractsDocsAction {
    type: typeof ContractActions.FETCH_CONTRACT_DOCS;
    payload: QueryParams;
    all?: any;
}

export function clearTotal(): any {
    return {
        type: successType(ContractActions.FETCH_CONTRACTS_TOTALS),
        payload: {},
        total: true,
    };
}

export function getContractsTotal(params: any): GetContractsAction {
    return {
        type: ContractActions.FETCH_CONTRACTS_TOTALS,
        payload: params,
    };
}

export function getContractDocs(params: QueryParams): GetContractsDocsAction {
    return {
        type: ContractActions.FETCH_CONTRACT_DOCS,
        payload: params,
    };
}
export interface DeleteContractAction {
    type: typeof ContractActions.DELETE_CONTRACT;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteContract(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteContractAction {
    return {
        type: ContractActions.DELETE_CONTRACT,
        payload: { id, onSuccess, onError },
    };
}

interface QueryParamsAll extends QueryParams {
    all?: any;
}

export interface GetContractAction {
    type: typeof ContractActions.FETCH_CONTRACT;
    payload: {
        id: string | number;
    };
}

export function getContract(id: string | number): GetContractAction {
    return {
        type: ContractActions.FETCH_CONTRACT,
        payload: { id },
    };
}

export interface CreateContractAction {
    type: typeof ContractActions.CREATE_CONTRACT;
    payload: {
        data: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createContract(
    data: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateContractAction {
    return {
        type: ContractActions.CREATE_CONTRACT,
        payload: { data, onSuccess, onError },
    };
}

export interface PersistContractAction {
    type: typeof ContractActions.PERSIST_CONTRACT;
    payload: {
        data: ContractFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistContract(data: ContractFormData, callbacks: SagaPromise<any>): PersistContractAction {
    return {
        type: ContractActions.PERSIST_CONTRACT,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistContract = (data: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistContract(data, { resolve, reject }));
    });
};

export interface SendContractToDocusignAction {
    type: typeof ContractActions.SEND_CONTRACT_TO_DOCUSIGN;
    payload: {
        data: ContractSendFormData;
        callbacks: SagaPromise<any>;
    };
}

export function sendToDocusign(data: ContractSendFormData, callbacks: SagaPromise<any>): SendContractToDocusignAction {
    return {
        type: ContractActions.SEND_CONTRACT_TO_DOCUSIGN,
        payload: {
            data,
            callbacks,
        },
    };
}

export interface RemindContractToDocusignAction {
    type: typeof ContractActions.REMIND_CONTRACT_TO_DOCUSIGN;
    payload: {
        data: ContractSendFormData;
        callbacks: SagaPromise<any>;
    };
}

export function remindDocusign(
    data: ContractSendFormData,
    callbacks: SagaPromise<any>,
): RemindContractToDocusignAction {
    return {
        type: ContractActions.REMIND_CONTRACT_TO_DOCUSIGN,
        payload: {
            data,
            callbacks,
        },
    };
}

export type Actions =
    | GetContractsAction
    | GetContractsDocsAction
    | GetContractAction
    | DeleteContractAction
    | CreateContractAction
    | PersistContractAction
    | SendContractToDocusignAction
    | RemindContractToDocusignAction;
